<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="hd-stage">
        <span class="hd-title"></span>
        <span class="hd-subtitle"></span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewHeading',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.hd-stage {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 140px;
}
.hd-title {
  display: block;
  height: 22px;
  width: 70%;
  border-radius: 6px;
  background: rgba(15, 15, 20, 0.78);
}
.hd-subtitle {
  display: block;
  height: 9px;
  width: 42%;
  border-radius: 999px;
  background: color-mix(in srgb, var(--accent) 60%, rgba(15, 15, 20, 0.2));
}
</style>
